'use client';

import { useCallback } from 'react';
import { useRouter } from 'next/navigation';
import { useActiveAccountId } from '@frameio/shared/contexts';
import {
  setPendingWorkspaceSettings,
  WORKSPACE_SETTINGS_PATH,
} from '@frameio/shared/settings/workspaceSettingsNavigation';

type OpenWorkspaceSettingsInput = {
  workspaceId: string;
};

export function useOpenWorkspaceSettings(): (
  input: OpenWorkspaceSettingsInput
) => void {
  const accountId = useActiveAccountId();
  const router = useRouter();

  return useCallback(
    ({ workspaceId }: OpenWorkspaceSettingsInput) => {
      if (!accountId || !workspaceId) {
        throw new Error(
          'An active account and workspace are required to open workspace settings.'
        );
      }

      // Keep this handoff in shared. Importing Settings scope code into the
      // globally mounted Workspaces graph causes recursive module evaluation.
      setPendingWorkspaceSettings({ accountId, workspaceId });
      router.replace(WORKSPACE_SETTINGS_PATH);
    },
    [accountId, router]
  );
}
